import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import { TableHead, Th, Tr, Td } from '../../Elements/DataTable';
import { UserContext } from '../../../context/UserContext';
import { formatApiDateTime } from '../../../lib/helpers';

const SociosModal = ({ children, handleBotonModalEditarSociosSalir, email, numeroSocio, userId }) => {
  const [pestanas, setPestanas] = useState(1);
  const [esEditable, setEsEditable] = useState(false);
  const [numeroSocioInput, setNumeroSocioInput] = useState(numeroSocio || '');
  const [emailSocioInput, setEmailSocioInput] = useState(email || '');
  const [transacciones, setTransacciones] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);
  const [token] = useContext(UserContext);
  const hasLoadedRef = useRef(false);

  const cargarHistorial = useCallback(async () => {
    setCargandoHistorial(true);
    try {
      // Solo las del socio de esta ficha (el filtro de abajo se queda como red):
      // pedir el club entero por modal era parte de la lentitud (Sentry 20-ago).
      const response = await fetch(`/v1/get-all-transactions?user_id=${userId}&limit=200`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const transaccionesUsuario = data.transactions.filter(
          t => t.user_id === userId && t.type === 'purchase'
        );
        setTransacciones(transaccionesUsuario);
      }
    } catch (error) {
      console.error('Error al cargar historial:', error);
    } finally {
      setCargandoHistorial(false);
    }
  }, [token, userId]);

  useEffect(() => {
    if (userId && token) {
      hasLoadedRef.current = true;
      cargarHistorial();
    }
    return () => {
      hasLoadedRef.current = false;
    };
  }, [userId, token, cargarHistorial]);

  useEffect(() => {
    if (pestanas === 2 && userId && token && !hasLoadedRef.current) {
      cargarHistorial();
    }
  }, [pestanas, userId, token, cargarHistorial]);

  const action = (i) => {
    setPestanas(i);
  };

  return (
    // <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4 overflow-auto">
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 backdrop-blur-sm">

      {/* <div className="relative bg-white w-full h-screen overflow-y-auto rounded-none shadow-xl p-6"> */}
      <div className="relative bg-white w-full max-h-screen overflow-y-auto rounded-none shadow-xl p-6">

        {/* <button
          onClick={handleBotonModalEditarSociosSalir}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold"
          aria-label="Cerrar modal"
        >
          X
        </button> */}

        <div className="pb-4 px-2">
          <p className="font-bold text-xl">{email ? `Socio: ${email}` : 'Socio'}</p>
        </div>

        {/* Pestañas */}
        <div className="flex border-b border-gray-300 justify-start">
          <div
            onClick={() => action(1)}
            className={`text-lg px-2 py-2 font-bold transition-colors duration-200 bg-white border-b-2 ${
              pestanas === 1
                ? 'text-gray-700 border-gray-700 cursor-default'
                : 'text-gray-400 border-transparent hover:text-gray-500 hover:border-gray-500 cursor-pointer'
            }`}
          >
            <p className="font-bold">Datos personales</p>
          </div>
          <div
            onClick={() => action(2)}
            className={`text-lg px-4 py-2 font-bold transition-colors duration-200 bg-white border-b-2 ${
              pestanas === 2
                ? 'text-gray-700 border-gray-700 cursor-default'
                : 'text-gray-400 border-transparent hover:text-gray-500 hover:border-gray-500 cursor-pointer'
            }`}
          >
            <p className="font-bold">Historial de consumo</p>
          </div>
        </div>

        {/* Contenido de la pestaña 1 */}
        <div
          className={`text-xl sm:text-lg relative ${
            pestanas === 1
              ? 'block mx-[10px] transition-all duration-1000 ease-in-out animate-fade'
              : 'hidden'
          }`}
        >
          <div className="flex justify-between items-center mb-6 pt-5">
            <h2 className="font-bold text-xl">{children}</h2>
            <button
              className="bg-blue-500 text-white rounded px-2 py-1 hover:bg-blue-600 transition font-bold"
              onClick={() => setEsEditable(true)}
            >
              Editar
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Columna izquierda */}
            <div className="flex flex-col space-y-4">
              <div className="flex flex-wrap gap-4">
                <div className="flex-1 min-w-[150px]">
                  <label>NºSocio</label>
                  <input
                    disabled={!esEditable}
                    value={numeroSocioInput}
                    readOnly
                    onChange={(e) => setNumeroSocioInput(e.target.value)}
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label>Nombre</label>
                  <input 
                    disabled={!esEditable}
                    placeholder="nombre" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`} 
                  />
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label>Apellidos</label>
                  <input 
                    disabled={!esEditable}
                    placeholder="apellidos" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <div className="flex-1 min-w-[150px]">
                  <label>DNI</label>
                  <input 
                    disabled={!esEditable}
                    placeholder="dni" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label>Fecha Nacimiento</label>
                  <input 
                    disabled={!esEditable}
                    placeholder="fecha nacimiento" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
                <div className="flex-1 min-w-[100px]">
                  <label>CP</label>
                  <input 
                    disabled={!esEditable}
                    placeholder="cp" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label>Ciudad</label>
                  <input 
                    disabled={!esEditable}
                    placeholder="ciudad" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <div className="flex-1 min-w-[150px]">
                  <label>Teléfono</label>
                  <input
                    disabled={!esEditable}
                    placeholder="teléfono" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label>Email</label>
                  <input
                    disabled={!esEditable}
                    value={emailSocioInput}
                    onChange={(e) => setEmailSocioInput(e.target.value)}
                    placeholder="email"
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
              </div>

              <div>
                <label>Documentos</label>
                <textarea 
                  disabled={!esEditable}
                  className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                />
              </div>
            </div>

            {/* Columna derecha */}
            <div className="flex flex-col space-y-4">
              <div>
                <label>Saldo Actual</label>
                <input 
                  disabled={!esEditable}
                  placeholder="saldo actual" 
                  className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                />
              </div>

              <div className="flex flex-wrap gap-4">
                <div className="flex-1 min-w-[150px]">
                  <label>Inscripción</label>
                  <input 
                    disabled={!esEditable}
                    placeholder="inscripción" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label>Caducidad</label>
                  <input 
                    placeholder="caducidad" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <div className="flex-1 min-w-[150px]">
                  <label>Socio Avalado</label>
                  <input 
                    disabled={!esEditable}
                    placeholder="socio avalado" 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label>Línea de Coste</label>
                  <select
                    disabled={!esEditable} 
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  >
                    <option value="defecto">--Defecto--</option>
                  </select>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <div className="flex-1 min-w-[150px]">
                  <label>Descuento</label>
                  <select 
                    disabled={!esEditable}
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  >
                    <option value="descuentos">--Descuentos--</option>
                    <option value="b5%">B - 5%</option>
                    <option value="b10%">B - 10%</option>
                    <option value="b50%">B - 50%</option>
                  </select>
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label>Cuota</label>
                  <select 
                    disabled={!esEditable}
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  >
                    <option value="tipoDeCuota">--Tipo de cuota--</option>
                  </select>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <div className="flex-1 min-w-[150px]">
                  <label>Consumo máx/mes</label>
                  <input 
                    disabled={!esEditable}
                    className={`border rounded w-full px-3 py-2 ${esEditable ? 'border-gray-300' : 'bg-gray-100 text-gray-500 cursor-not-allowed'}`}
                  />
                </div>
                <div className="flex-1 min-w-[150px]">
                  <label className="block mb-1">Tipo de consumo</label>
                  <div className="flex gap-4">
                    <label><input 
                              disabled={!esEditable}
                              type="checkbox" 
                              className="mr-1" 
                          /> 
                            Lúd.
                    </label>
                    <label><input 
                              disabled={!esEditable}
                              type="checkbox" 
                              className="mr-1" 
                          />
                            Terap.
                    </label>
                  </div>
                  <div className='pt-5'>
                    <button
                      onClick={handleBotonModalEditarSociosSalir}
                      className='bg-white text-blue-700 pr-4 pl-8'
                    >
                      Cancelar
                    </button>
                    <button
                      className='bg-blue-500 text-white font-bold rounded px-2 py-1'
                    >
                      Guardar cambios
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pestaña 2: Historial de consumo */}
        <div
          className={`text-xl sm:text-lg relative ${
            pestanas === 2
              ? 'block mx-[10px] transition-all duration-1000 ease-in-out animate-fade'
              : 'hidden'
          }`}
        >
          <div className="flex justify-between items-center mb-6 pt-5">
            <h2 className="font-bold text-xl">Historial de Productos Comprados</h2>
            <button
              className="bg-blue-500 text-white rounded px-3 py-1 hover:bg-blue-600 transition font-bold text-sm"
              onClick={cargarHistorial}
              disabled={cargandoHistorial}
            >
              {cargandoHistorial ? 'Cargando...' : '🔄 Actualizar'}
            </button>
          </div>

          {cargandoHistorial ? (
            <div className="text-center py-8">
              <p>Cargando historial...</p>
            </div>
          ) : transacciones.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-gray-500">No hay compras registradas</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm text-gray-700 border">
                {/* La ÚNICA tabla del producto con rejilla (borde en cada celda), y a
                    propósito: la fecha agrupa varias líneas con `rowSpan` y sin las
                    verticales no se ve dónde empieza y acaba cada compra. Todo lo
                    demás —cabecera, colores— sí es del sistema. */}
                <TableHead>
                  <Th className="border">Fecha</Th>
                  <Th className="border">Producto</Th>
                  <Th align="right" className="border">Cantidad</Th>
                  <Th align="right" className="border">Precio Unit.</Th>
                  <Th align="right" className="border">Total</Th>
                </TableHead>
                <tbody>
                  {transacciones.map((transaccion) => (
                    transaccion.items && transaccion.items.length > 0 ? (
                      transaccion.items.map((item, itemIndex) => (
                        <Tr key={`${transaccion.id}-${itemIndex}`}>
                          {itemIndex === 0 && (
                            <Td
                              className="border px-4 py-2 align-top"
                              rowSpan={transaccion.items.length}
                            >
                              {formatApiDateTime(transaccion.timestamp)}
                            </Td>
                          )}
                          <Td className="border px-4 py-2">{item.product_name}</Td>
                          <Td align="right" className="border px-4 py-2">
                            {item.quantity ? Number(item.quantity).toFixed(2) : '0.00'}
                          </Td>
                          <Td align="right" className="border px-4 py-2">
                            €{item.unit_price ? Number(item.unit_price).toFixed(2) : '0.00'}
                          </Td>
                          <Td align="right" className="border px-4 py-2 font-semibold">
                            €{(Number(item.quantity) * Number(item.unit_price)).toFixed(2)}
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr key={transaccion.id}>
                        <Td className="border px-4 py-2">
                          {formatApiDateTime(transaccion.timestamp)}
                        </Td>
                        <Td className="border px-4 py-2 italic text-[var(--muted-foreground)]" colSpan="4">
                          Sin productos registrados
                        </Td>
                      </Tr>
                    )
                  ))}
                </tbody>
                <tfoot className="bg-[var(--surface-subtle)] font-bold">
                  <tr>
                    <td colSpan="4" className="px-4 py-3 text-right border">Total general:</td>
                    <td className="px-4 py-3 text-right border">
                      €{transacciones.reduce((sum, t) => 
                        sum + (t.items || []).reduce((itemSum, item) => 
                          itemSum + (item.quantity * item.unit_price), 0
                        ), 0
                      ).toFixed(2)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SociosModal;
